import { boxSlotKeys } from "@/modules/boxSlot/gateway/boxSlotKeys"
import { BoxSessionDetailsEntity } from "@/modules/boxSlotSession/entities/boxSessionEntity"
import type { BoxSessionUpdateInputDto } from "@/modules/boxSlotSession/gateway/boxSlotSessionDto"
import { boxSlotSessionKeys } from "@/modules/boxSlotSession/gateway/boxSlotSessionKey"
import { useServicesContext } from "@/modules/core/services/services.context"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export function useBoxSlotUpdateSession() {
  const { boxSlotSessionApi } = useServicesContext()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({
      sessionId,
      sessionUpdateInputDto,
    }: {
      sessionId: string
      sessionUpdateInputDto: BoxSessionUpdateInputDto
    }) => {
      const result = await boxSlotSessionApi.updateSession(sessionId, sessionUpdateInputDto)
      return BoxSessionDetailsEntity.fromDto(result)
    },
    onSuccess: async (data, variables) => {
      await queryClient.setQueryData(boxSlotSessionKeys.session(variables.sessionId), data)
      await queryClient.invalidateQueries({
        queryKey: boxSlotSessionKeys.all,
      })
      await queryClient.invalidateQueries({
        queryKey: boxSlotKeys.all,
      })
    },
  })
}
